
  // Function to hide all forms and their next sibling elements
  function hideAllForms() {
    const formEmbeds = document.querySelectorAll("#app-embed");
    formEmbeds.forEach(function(embed) {
      const formContainers = embed.shadowRoot.querySelectorAll('form');
      formContainers.forEach(function(container) {
        container.style.display = 'none';
        const nextElement = container.nextElementSibling;
        if (nextElement) {
          nextElement.style.display = 'none';
        }
      });
    });
  }

  // Function to show or hide the form associated with the clicked header
  function toggleForm(header) {
    const formToShow = header.nextElementSibling.nextElementSibling; // Adjust this if needed
    if (!formToShow) return; // No form to show
    // Check if the form is currently displayed
    const isCurrentlyVisible = formToShow.style.display === 'block';
    // Hide all forms
    hideAllForms();
    // Show the form if it was previously hidden
    if (!isCurrentlyVisible) {
      formToShow.style.display = 'block';
    }
    //console.log('Form to show or hide:', formToShow);
  }

  // Function to check for form headers and add buttons
  function checkAndAddButton() {
    const formEmbeds = document.querySelectorAll("#app-embed");
    var   counter     = 0;
    formEmbeds.forEach(function(embed) {
      const formHeaders = embed.shadowRoot.querySelectorAll('#form-container-ref ._formHeader_1ll8d_19');
     
      if(formHeaders.length > 0){
        hideAllForms();
        formHeaders.forEach(function(header) {
          if (!header.nextElementSibling || header.nextElementSibling.tagName !== 'BUTTON') {
            const button = document.createElement('button');
            button.textContent = 'GET CODE';
            button.className = 'custom-btn';
            button.style.marginTop = '10px';
            header.parentNode.insertBefore(button, header.nextSibling);
            button.addEventListener('click', function() {
              toggleForm(header);
            });
          }
        });
       // clearInterval(intervalId);
       
      }
      counter = counter + 1;
    });

     if(counter == 2){
       clearInterval(intervalId);
       const formEmbeds = document.querySelectorAll("form-embed");
       console.log('formEmbeds.length')
       console.log(formEmbeds.length)
        if(formEmbeds.length>0){
          formEmbeds.forEach(function(embed) {
            const shadowRoot = embed.shadowRoot;
            if (shadowRoot) {
              const style = document.createElement('style');
              style.textContent = `
                   #form-container-ref ._formHeader_1ll8d_19 {
                    	min-height: 60px;
                    }
                    #form-container-ref h2{
                      font-family: Manrope, sans-serif;
                      color: #003c38;
                      font-weight: 700;
                    }
                    #form-container-ref p{
                      color: #819291;
                      font-size: 18px;
                      line-height: 24px;
                      font-weight: 400;
                    }
                    #form-container-ref form input{
                     border: 1px solid rgb(194, 194, 194);
                      color: rgb(51, 51, 51);
                      font-size: 14px;
                      line-height: 48px;
                      height: 48px;
                      padding: 0px 15px;
                      margin-bottom: 10px;
                    }
                   #form-container-ref form button{
                    margin-top: 10px;
                   }
                    .custom-btn {
                    	margin-top: 10px;
                    	background-color: #003733 !important;
                    	border: 1px solid #003733;
                    	border-radius: 25px;
                    	color: #fff !important;
                    	display: table;
                    	font-size: 15px;
                    	font-weight: 800;
                    	height: 48px;
                    	line-height: 48px;
                    	padding: 0 40px;
                    	transition: all ease .3s;
                    	width: auto;
                    	text-transform: uppercase;
                    	border: none;
                    	margin: 20px auto !important;
                    }
                    .custom-btn:hover {
                    	background-color: transparent !important;
                    	border: 1px solid #d6d6d6;
                    	color: #003733 !important;
                    	transition: all ease .3s;
                    }
                /* Add more custom styles here */
              `;
              shadowRoot.appendChild(style);
            }
          });
        }
     }
  }

  // Check for the element every 500ms until it's found
  const intervalId = setInterval(checkAndAddButton, 100);

  // Optional: Stop the interval after a maximum of 10 seconds (safety stop)
  //setTimeout(() => clearInterval(intervalId), 10000);
document.querySelector(".form_trigger_desktop ").addEventListener('click',function (){
       window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', 'XXDfkB']);
    });
